/* Was die Seite im Shop zusaetzlich braucht. */
(function(){
  /* Nach einem Neuladen meldet Shopify den Erfolg ueber die Seite selbst.
     Dann zeigt der Kasten dieselbe Bestaetigung wie auf der Website. */
  var da = document.querySelector('[data-angemeldet]');
  if (da){
    var kasten = da.closest('.sub, .float');
    if (kasten) kasten.classList.add('sent');
  }

  /* Eintragen ohne Neuladen. Shopifys Formular schickt den Besucher sonst auf
     eine neue Seite - die Website springt nach oben und faehrt wieder zum
     Formular herunter. Hier geht die Adresse im Hintergrund an Shopify, die
     Seite bleibt stehen, und die Bestaetigung erscheint wie auf der Website
     sofort (das erledigt das Skript der Seite beim Absenden).
     Antwortet Shopify nicht mit einem klaren Ja - etwa weil es erst eine
     Sicherheitsabfrage zeigen will -, wird das Formular doch auf dem normalen
     Weg abgeschickt. So geht keine Anmeldung verloren. */
  var form = document.getElementById('anmeldung');
  if (!form || !window.fetch || !window.FormData) return;
  form.addEventListener('submit', function(ereignis){
    ereignis.preventDefault();
    var daten = new FormData(form);
    var feld = form.querySelector('input[type="email"]');
    var adresse = feld ? feld.value : '';
    function normal(){
      /* Das Skript der Seite leert das Feld kurz nach dem Absenden. */
      if (feld) feld.value = adresse;
      form.submit();
    }
    fetch(form.getAttribute('action'), {
      method: 'POST', body: daten, credentials: 'same-origin', headers: {'Accept': 'text/html'}
    }).then(function(antwort){
      if (!/[?&]customer_posted=true/.test(antwort.url)) normal();
    }).catch(normal);
  });
})();

/* Zwei kleine Helfer, mehr braucht der Shop nicht:
   - Mengenwahl: Minus und Plus neben dem Zahlenfeld
   - Galerie: Daumenbild anklicken, grosses Bild wechselt */
(function () {
  document.querySelectorAll('[data-menge]').forEach(function (kasten) {
    var feld = kasten.querySelector('input');
    if (!feld) return;
    var min = parseInt(feld.min, 10);
    if (isNaN(min)) min = 0;
    kasten.addEventListener('click', function (e) {
      var knopf = e.target.closest('[data-schritt]');
      if (!knopf) return;
      var wert = parseInt(feld.value, 10);
      if (isNaN(wert)) wert = min;
      wert = Math.max(min, wert + parseInt(knopf.dataset.schritt, 10));
      feld.value = wert;
      feld.dispatchEvent(new Event('change', { bubbles: true }));
    });
    /* Im Warenkorb schickt jede Aenderung das Formular ab - sonst stimmt die
       Summe darunter nicht mehr mit den Zahlen darueber ueberein. */
    if (kasten.hasAttribute('data-absenden')) {
      feld.addEventListener('change', function () {
        if (feld.form) feld.form.submit();
      });
    }
  });

  document.querySelectorAll('[data-galerie]').forEach(function (galerie) {
    var haupt = galerie.querySelector('[data-haupt]');
    if (!haupt) return;
    galerie.addEventListener('click', function (e) {
      var knopf = e.target.closest('button[data-gross]');
      if (!knopf) return;
      haupt.removeAttribute('srcset');
      haupt.src = knopf.dataset.gross;
      haupt.alt = knopf.dataset.alt || '';
      galerie.querySelectorAll('button[data-gross]').forEach(function (b) {
        b.removeAttribute('aria-current');
      });
      knopf.setAttribute('aria-current', 'true');
    });
  });
})();

/* Mengenrabatt: Kacheln setzen die Menge, Preis und Summe rechnen mit.
   Abgezogen wird der Rabatt von Shopify im Warenkorb (automatische Rabatte);
   die Prozente stehen in der Einstellung "Staffel" des Abschnitts. */
(function () {
  function euro(c) {
    var e = c / 100;
    return (e % 1 ? e.toFixed(2).replace('.', ',') : String(e)) + ' €';
  }
  document.querySelectorAll('[data-staffel]').forEach(function (st) {
    var wurzel = st.closest('.pane') || document;
    var feld = wurzel.querySelector('.kauf input[name="quantity"]');
    if (!feld) return;
    var basis = parseInt(st.dataset.basis, 10);
    var frei = parseInt(st.dataset.frei, 10) || 0;
    var stufen = st.dataset.stufen.split(',').map(function (s) {
      var t = s.split(':');
      return { ab: parseInt(t[0], 10), p: parseInt(t[1], 10) };
    }).sort(function (a, b) { return a.ab - b.ab; });
    var knoepfe = st.querySelectorAll('[data-menge-wahl]');
    var summe = st.querySelector('[data-staffel-summe]');
    var stueckEl = wurzel.querySelector('[data-preis-stueck]');
    var altEl = wurzel.querySelector('[data-preis-alt]');
    var proEl = wurzel.querySelector('[data-preis-pro]');

    function rechne() {
      var n = Math.max(1, parseInt(feld.value, 10) || 1);
      var p = 0, aktiv = 1;
      stufen.forEach(function (s) { if (n >= s.ab) { p = s.p; aktiv = s.ab; } });
      var stueck = Math.round(basis * (100 - p) / 100);
      knoepfe.forEach(function (k) {
        k.setAttribute('aria-pressed', parseInt(k.dataset.mengeWahl, 10) === aktiv ? 'true' : 'false');
      });
      if (stueckEl) stueckEl.textContent = euro(stueck);
      if (altEl) { altEl.textContent = euro(basis); altEl.hidden = !p; }
      if (proEl) proEl.hidden = n < 2;
      if (!summe) return;
      var t = '';
      if (n > 1) {
        t = '<b>' + n + ' Spiele: ' + euro(stueck * n) + '</b>';
        if (p) t += ' statt ' + euro(basis * n) + ' &middot; <span class="spar">du sparst ' + euro((basis - stueck) * n) + '</span>';
        if (frei) {
          if (n >= frei) t += ' &middot; Versand frei (DE)';
          else t += ' &middot; noch ' + (frei - n) + ' bis Versand frei (DE)';
        }
      }
      summe.hidden = !t;
      summe.innerHTML = t;
    }
    knoepfe.forEach(function (k) {
      k.addEventListener('click', function () {
        feld.value = k.dataset.mengeWahl;
        feld.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    feld.addEventListener('change', rechne);
    feld.addEventListener('input', rechne);
    rechne();
  });
})();

/* "noch X Tage" bis zum Ende der Kampagne (Abschnitt Bestellen). */
(function () {
  document.querySelectorAll('[data-tage]').forEach(function (el) {
    var ende = Date.parse(el.dataset.ende);
    if (isNaN(ende)) return;
    var tage = Math.ceil((ende - Date.now()) / 864e5);
    el.textContent = tage > 1 ? 'noch ' + tage + ' Tage' : (tage === 1 ? 'letzter Tag' : 'beendet');
  });
})();
